import React from "react";
import { useDispatch, useSelector } from "react-redux";

/**
 * Higher-Order Component that provides Redux dispatch and useSelector
 * @param {Function} mapStateToProps - Function to select state from Redux store
 * @param {Function} mapDispatchToProps - Function to map dispatch actions (optional)
 * @returns {Function} HOC function that wraps components
 */
const withRedux = (mapStateToProps, mapDispatchToProps) => {
  return WrappedComponent => {
    const WithReduxComponent = props => {
      const dispatch = useDispatch();
      const selectedState = useSelector(mapStateToProps || (() => ({})));

      // If mapDispatchToProps is provided, call it with dispatch
      const dispatchProps = mapDispatchToProps
        ? mapDispatchToProps(dispatch)
        : { dispatch };

      return (
        <WrappedComponent {...props} {...selectedState} {...dispatchProps} />
      );
    };

    // Set display name for debugging
    WithReduxComponent.displayName = `withRedux(${WrappedComponent.displayName ||
      WrappedComponent.name})`;

    return WithReduxComponent;
  };
};

export default withRedux;
